export class SSSA extends HTMLElement{
    constructor(){
        super();
    }
}